import { Component, OnInit, OnDestroy, ViewChild, ElementRef, AfterViewInit, ChangeDetectorRef, AfterViewChecked, AfterContentChecked, ChangeDetectionStrategy } from '@angular/core';
import { INDRAExtraSidebar } from '@ibe.components/shared/sidebar-views/ancillaries/extra-sidebar.indra.abstract';
import { SidebarService } from '@ibe/services/ui';
import { ActivatedRoute, Router } from '@angular/router';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { INDRAMybService } from '@ibe/services';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import {
	TRANSLATION_ANCILLARY_DETAILED,
	EXTRAS_ANCILLARY_PREF_BOARD,
	TRANSLATION_ANCILLARIES_TYPE,
	TRANSLATION_ANCILLARY_TEXTS,
	TRANSLATION_ANCILLARY_TITLE,
	TRANSLATION_PREF_BOARD,
	TRANSLATION_ANCILLARY_LABEL,
	ANCILLARY_PRODUCT_GROUP_CODE_PREF_BOARD,
	EQUIPMENT_CODE_TRAIN,
	EQUIPMENT_CODE_BUS,
	TRANSLATION_ANCILLARY_SUBTITLE,
	TRANSLATION_ANCILLARY_ARIA_LABEL,
	SESSION_VAR_KEY_LANGUAGE,
	SESSION_VAR_KEY_MARKET,
	DEFAULT_LANGUAGE,
	DEFAULT_MARKET,
	SPECIAL_CASE_MARKET_LANGUAGE_MAP,
	SSR_CODE_FIREARMS,
	SSR_CODE_SPORTS_SPORTING_EQUIPMENT,
	ANCILLARY_PRODUCT_PACKS,
	SSR_CODE_PREF_BOARD
} from '@ibe.config';
import { INDRAAncillariesSelectionService } from '@ibe.services/ancillaries-selection.indra.service';
import { INDRAAncillariesShoppingCartService } from '@ibe.services/ancillaries-shopping-cart.indra.service';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRAIncludedAncillaryDetailForSegment } from '@ibe.models/ancillary.indra.model.lib';
import { Subscription } from 'rxjs';
import { INDRADateService } from '@ibe.services/date.indra.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { Store } from '@ngrx/store';
import * as fromStore from '@ibe/store/index';
import { INDRAGoogleAnalyticsService } from '@ibe.services/google.analytics.indra.service';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
import { PaymentService } from '@ibe.components/shared/payment/payment.service';
import { INDRACurrencyPipe } from '@ibe.services/currency.indra.pipe';
import { INDRABookedTripDetails } from '@ibe.models/booked-trip-details.indra.model.lib';
import { INDRAPackService } from '../pack/pack.service.indra';

@Component({
	selector: 'app-extra-pref-board',
	templateUrl: './preferred-boarding.indra.component.html',
	styleUrls: ['./preferred-boarding.component.scss'],
	providers: [INDRACurrencyPipe],
	host: {
		class: 'app-extra-pref-board'
	}
})
export class INDRAExtraPrefBoardComponent extends INDRAExtraSidebar
	implements OnInit, AfterViewInit, OnDestroy {
	notificationMessage: string;

	formsPerPassenger: FormGroup[];

	translationAncillaryDetailedKey = TRANSLATION_ANCILLARY_DETAILED;
	paxPurchaseFeatures = [];
	startingPrice;
	activeBookedTrip;

	allSubscriptions: Subscription[] = [];
	paramSubscription: Subscription;
	loadedSubscription: Subscription;
	packSubscription: Subscription;

	isMYB: boolean = false;

	notificationShowing: boolean;
	lastActiveElement;
	notificationDuration = 2.5; // in seconds

	milesNeeded = 0;
	addedAncillary: any = [];
	removedAncillary: any;
	isModificationDisallowed: boolean = false;
	booked_trip: INDRABookedTripDetails;
	notEnoughMilesFlag: boolean = false;
	hasAddedExtrasFlag: boolean;

	aggregateSale: string = null;

	stops = [];
	selectedStop: number;
	flightStop: any;
	isElegibleFlag: boolean = true;
	addedByPack: boolean = false;
	prevFlightId: any;
	show: boolean = false

	language: string;


	@ViewChild('sidebar__notification') $notification: ElementRef;

	constructor(
		sidebarService: SidebarService,
		route: ActivatedRoute,
		router: Router,
		bookingService: INDRABookingService,
		mybService: INDRAMybService,
		ibeAdminService: INDRAIbeAdminService,
		ancillariesSelectionSrv: INDRAAncillariesSelectionService,
		ancillariesShoppingCartSrv: INDRAAncillariesShoppingCartService,
		private fb: FormBuilder,
		private bfmStorage: INDRABFMDataStorageService,
		dateService: INDRADateService,
		googleAnalytics: INDRAGoogleAnalyticsService,
		storageService: INDRAStorageService,
		store: Store<fromStore.State>,
		private ibeAdminConfigService: INDRAIbeAdminConfigService,
		protected currencyPipe: INDRACurrencyPipe,
		protected paymentInfoService: PaymentService,
		private cdr: ChangeDetectorRef,
		private packService: INDRAPackService
	) {
		super(sidebarService, route, router, bookingService, mybService, ibeAdminService, ancillariesSelectionSrv, ancillariesShoppingCartSrv, EXTRAS_ANCILLARY_PREF_BOARD, dateService, googleAnalytics, storageService, store, currencyPipe, paymentInfoService);
		this.formsPerPassenger = [];

		this.loadedSubscription = this.isLoaded.subscribe(
			res => {
				if (res) {
					this.showNotification('addMoreSidebars.specialMeals.texts.appliedSuccessfullyToOtherFlights');
				}
			}
		);
		this.allSubscriptions.push(this.loadedSubscription);

		// get 'isBookingCreated' if existing in URL query params (if true, modification in the sidebar is not allowed)
		const isBookingCreatedParam = this.route.snapshot.paramMap.get('isBookingCreated');
		if (isBookingCreatedParam === 'true') {
			this.isModificationDisallowed = true;
		}
	}
	ngOnInit() {
		if (this.router.url.includes('/my-bookings/details')) this.isMYB = true;
		this.storageService.set('ancType', EXTRAS_ANCILLARY_PREF_BOARD);

		this.booked_trip = this.bfmStorage.INDRA_getActiveBookedTrip();

		this.paramSubscription = this.route.params.subscribe(params => {
			this.flightCardId = this.route.snapshot.paramMap.get('flight');
			this.flight = this.bookingService.INDRA_getBookedFlight(this.flightCardId);
			if (params.aggregateSale && params.aggregateSale != null && params.aggregateSale != undefined && params.aggregateSale != 'undefined') {
				this.aggregateSale = params.aggregateSale;
			}
			this.flightRouteInput = (!this.aggregateSale) ? this.bookingService.INDRA_getFlightRoute(this.flight) : this.bookingService.INDRA_getFlightRouteAggregate(this.flight, this.aggregateSale);
			if (this.INDRA_hasNextOrPreviousFlight()) {
				//METHOD: ENABLE THIS FUNCTION ONLY FOR MULTIPLE FLIGHT CARDS
				this.INDRA_loadChangeFlightCard(this.flightRouteInput.idFlight)
			}

			this.passengers = this.bookingService.INDRA_getPaxInfo(false);

			this.passengers.forEach(passenger =>
				this.formsPerPassenger.push(this.createFormGroup())
			);

			this.language = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
				sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
			super.ngOnInit();
		});
		// const purchasedAncillaryWithSegmentInfo = this.bookingService.INDRA_getPassengersPurchasedAncillaryWithSegmentInfo(ANCILLARY_PRODUCT_GROUP_CODE_PREF_BOARD, this.flight.idFlight.toString(), this.flightCardId);

		// this.passengers.forEach(pax => {
		// 	const purchasedIndex = purchasedAncillaryWithSegmentInfo.findIndex(
		// 		object => object[pax.idPax]
		// 	);

		// 	if (purchasedIndex === -1) {
		// 		this.paxPurchaseFeatures.push({
		// 			[pax.idPax]: []
		// 		});
		// 	} else {
		// 		const paxpurchasedAncillaries = purchasedAncillaryWithSegmentInfo[purchasedIndex];
		// 		this.paxPurchaseFeatures.push({
		// 			[pax.idPax]: this.INDRA_constructAncillaryListForPurchased(paxpurchasedAncillaries[pax.idPax])
		// 		});
		// 	}
		// });


		this.activeBookedTrip = this.bfmStorage.INDRA_getActiveBookedTrip();
		const priceList = this.paxAddOnFeatures[this.flightCardId].map(Object.values).map(function (subarray) {
			return subarray.map(function (number) {
				return number.map(function (val) {
					return val.price;
				});
			});
		});

		if (!this.INDRA_hasNextOrPreviousFlight()) {
			this.INDRA_loadSegmentedControlRadio();
		}

		const filteredPrice = priceList.map(nestedarr => nestedarr.find(element => element.length > 0));
		this.startingPrice = filteredPrice.filter(value => value != undefined).reduce((a, b) => Math.min(a, b)).toString();
		for (const i in this.passengers) {
			const feature = this.INDRA_getAddedAncillariesForPassenger(this.passengers[i].idPax);
			if (feature) {
				const shoppingCartItems = this.storageService.get('INDRAAncillariesShoppingCartService.shoppingCart');
				for (const x in feature) {
					this.addedAncillary.push(feature[x]);
					this.milesNeeded = this.milesNeeded + feature[x].points;
				}
				// this.payWithMiles = shoppingCartItems.itemsAdded.find(item => item.type == feature.type).payWithMiles;
			}
		}


		for (const i in this.passengers) {
			const feature = this.INDRA_getAddedAncillariesForPassengerSegment(this.passengers[i].idPax, this.selectedStop + 1);
			if (feature.length != 0) {
				const shoppingCartItems = this.storageService.get('INDRAAncillariesShoppingCartService.shoppingCart');
				this.addedAncillary.push(feature);
				// this.milesNeeded = this.milesNeeded + feature[0].points;
				// this.payWithMiles = shoppingCartItems.itemsAdded.find(item => item.type == feature[0].type).payWithMiles;
			}
		}

		this.payWithMiles = this.INDRA_isPayWithMiles();
		this.allSubscriptions.push(this.paramSubscription);
		// this.startingPrice = this.paxAddOnFeatures[this.flightCardId][0][1].reduce(((sum, item) => sum + (item.type === this.ancillariesType ? parseFloat(item.price.toString()) : 0)), 0);
		this.hasAddedExtrasFlag = this.INDRA_getInitialAddedExtras(EXTRAS_ANCILLARY_PREF_BOARD);
	}

	ngAfterViewInit() {
		this.cdr.detectChanges();
	}

	INDRA_gotoURL(key) {
		const languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
			sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
		const languageMap = SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] ? SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] : languageCode;
		const marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
			sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
		const urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
		const urlNavigate = urlIbeAdmin.replace('${lang}', `${languageMap}`).replace('${market}', `${marketCode}`);
		return window.open(urlNavigate);
	}

	private createFormGroup() {
		return this.fb.group({
			fasttrackAdd: null,
			weightCheck: false,
			dimensionCheck: false
		});
	}


	INDRA_hasNextFlight() {
		// return this.bookingService.INDRA_hasNextFlight(this.flightCardId) && this.INDRA_checkIfNextFlightCardhasPrefBoardOnFirstSegmentOnly();
		return this.bookingService.INDRA_hasNextFlight(this.flightCardId);
	}

	INDRA_copyToOtherFlights() {
	}

	INDRA_flowActionsClasses() {
		return { 'flow_actions--wide': !this.INDRA_hasNextFlight() };
	}

	INDRA_handleNext() {
		const nextFlightIdentifier = this.bookingService.INDRA_getNextFlightCardId(this.flightCardId);
		if (nextFlightIdentifier > 0) {
			this.router.navigate([
				{ outlets: { sidebar: ['preferred-boarding', { flight: nextFlightIdentifier }] } }
			]);
		} else {
			super.INDRA_handleClose();
		}
	}


	INDRA_printAddButtonLabel(idPax: number) {
		const features = this.INDRA_getAddOnForPassenger(idPax);
		let activeFeature = [];
		if (features && features.length > 0) {
			activeFeature = features.map(data => {
				if (data && data.segmentId === (this.flightStop.idInfoSegment)) {
					return data;
				}
			});
			activeFeature = activeFeature.filter(function (element) {
				return element !== undefined && element != false;
			});
		}

		return this.INDRA_getTranslation(`${this.translationAncillaryDetailedKey + activeFeature[0].code}`)
			+ ' ('
			+ this.currencyPipe.transform((activeFeature[0].price)) + ' '
			+ this.INDRA_getCurrencySymbol(activeFeature[0].currency)
			+ ')';
	}

	INDRA_isElegibleWithPrefBoard(idPax: number) {
		this.isElegibleFlag = true;
		const features = this.INDRA_getAddOnForPassenger(idPax);

		let activeFeature = [];
		if (features && features.length > 0) {
			activeFeature = features.map(data => {
				if (data && data.segmentId === (this.flightStop.idInfoSegment)) {
					return data;
				} else {
					return false;
				}
			});
			activeFeature = activeFeature.filter(function (element) {
				return element !== undefined && element != false;
			});
		}

		if (!activeFeature || activeFeature.length <= 0) {
			this.isElegibleFlag = false;
		}

		this.INDRA_checkAncillaryInPack();
		return this.isElegibleFlag && !this.addedByPack;
	}

	INDRA_printAddedButtonLabel(idPax: number) {
		let features = [];
		let feature = [];
		features = this.INDRA_getAddedAncillariesForPassenger(idPax);
		if (features && features.length > 0) {
			feature = features.map(data => {
				if (data && data.segmentId === Number(this.flightStop.idInfoSegment)) {
					return data;
				}
			});
			feature = feature.filter(function (element) {
				return element !== undefined && element != false;
			});
		}


		return this.INDRA_getTranslation(`${this.translationAncillaryDetailedKey + feature[0].code}`);
	}

	INDRA_printRemoveButtonLabel(idPax: number) {
		let features = [];
		let feature = [];
		if (this.ancillariesType === EXTRAS_ANCILLARY_PREF_BOARD) {
			features = this.INDRA_getAddedAncillariesForPassenger(idPax);

			if (features && features.length > 0) {
				feature = features.map(data => {
					if (data && data.segmentId === Number(this.flightStop.idInfoSegment)) {
						return data;
					}
				});
				feature = feature.filter(function (element) {
					return element !== undefined && element != false;
				});
			}
		} else {
			features = this.INDRA_getAddedAncillariesForPassenger(idPax);
			feature = features;
		}

		return feature[0].price + this.INDRA_getCurrencySymbol(feature[0].currency);
	}

	INDRA_getTitle() {
		return this.INDRA_getTranslation(`${TRANSLATION_ANCILLARIES_TYPE + 'PREFBOARD'}`);
	}

	INDRA_getTextTranslation(lastKey: string) {
		const key = TRANSLATION_PREF_BOARD + TRANSLATION_ANCILLARY_TEXTS + lastKey;
		return key;
	}

	INDRA_getTitleTranslation(lastKey: string) {
		const key = TRANSLATION_PREF_BOARD + TRANSLATION_ANCILLARY_TITLE + lastKey;
		return key;
	}

	INDRA_getLabelTranslation(lastKey: string) {
		const key = TRANSLATION_PREF_BOARD + TRANSLATION_ANCILLARY_LABEL + lastKey;
		return key;
	}

	INDRA_getAriaLabelTranslation(lastKey: string) {
		const key = TRANSLATION_PREF_BOARD + TRANSLATION_ANCILLARY_ARIA_LABEL + lastKey;
		return key;
	}

	INDRA_getSubTitle(key1: string, key2: string) {
		const keyValue1 = this.INDRA_getTranslation(`${TRANSLATION_PREF_BOARD + TRANSLATION_ANCILLARY_SUBTITLE + key1}`);
		const keyValue2 = this.INDRA_getTranslation(`${TRANSLATION_PREF_BOARD + TRANSLATION_ANCILLARY_SUBTITLE + key2}`);
		const currency = this.activeBookedTrip['ancillaries-data']['bundleList'][0].ancillaryList[0].catalog[0].passengers[0].codeList[0].currency;
		const startingPriceFormat = this.currencyPipe.transform((this.startingPrice));
		return keyValue1 + ' ' + startingPriceFormat + this.INDRA_getCurrencySymbol(currency ? currency : '') + ' ' + keyValue2;
	}

	INDRA_checkIfNextFlightCardhasPrefBoardOnFirstSegmentOnly() {
		const nextFlightIdentifier = this.bookingService.INDRA_getNextFlightCardId(this.flightCardId);
		const flight_tickets = this.bfmStorage.INDRA_getFlightTickets();
		const nextFlightCardsInfo = flight_tickets.filter(ticket => {
			if (ticket.type === 'flight' && ticket.item.details.assignedFlightId == nextFlightIdentifier) {
				return true;
			}
			return false;
		});
		return (nextFlightCardsInfo.length > 0 && nextFlightCardsInfo[0].item.extras.includes(EXTRAS_ANCILLARY_PREF_BOARD) ? true : false);

	}

	INDRA_constructAncillaryListForPurchased(list: any[]): INDRAIncludedAncillaryDetailForSegment[] {
		const returnValue: INDRAIncludedAncillaryDetailForSegment[] = [];
		list.forEach(segment => {
			returnValue.push({
				ancillaryDetail: '',
				segmentId: segment.segmentId,
				unconfirmed: segment.ancillaryList[0].unconfirmed
			});
		});

		return returnValue;
	}

	INDRA_getPurchasedAncillaryForPassenger(idPax: number): string[] {
		let returnValue: string[] = [];
		const index = this.paxPurchaseFeatures.findIndex(
			item => Object.keys(item)[0] === idPax.toString()
		);
		if (this.paxPurchaseFeatures) {
			const paxAncillary = this.paxPurchaseFeatures[index];
			returnValue = paxAncillary[idPax];
			return returnValue;
		}
	}

	INDRA_isPresentOnFareInformation() {
		return this.bookingService.INDRA_isPresentOnFareInformation(ANCILLARY_PRODUCT_GROUP_CODE_PREF_BOARD, this.flightCardId);
	}


	INDRA_isPassengerPresentOnTierLevel(passengers = []) {
		return this.bookingService.INDRA_isPassengerPresentOnTierLevel(ANCILLARY_PRODUCT_GROUP_CODE_PREF_BOARD, passengers);
	}

	INDRA_getStopoverNotificationTitle() {
		return this.INDRA_getTranslation('addMoreSidebars.fasttrack.titles.fasttrackForWhole') + ' '
			+ this.INDRA_getBoundType() + ' ' +
			this.INDRA_getTranslation('addMoreSidebars.fasttrack.titles.trip');
	}

	ngOnDestroy() {
		for (const sub of this.allSubscriptions) {
			if (sub) {
				sub.unsubscribe();
			}
		}
	}

	private showNotification(message: string) {
		this.notificationMessage = this.INDRA_getTranslation(message);
		this.notificationShowing = true;
		window.setTimeout(this.dismissNotification.bind(this), this.notificationDuration * 1000);

		this.lastActiveElement = document.activeElement;
		// this.$notification.nativeElement.focus();
	}

	dismissNotification() {
		this.notificationShowing = false;
		this.lastActiveElement.focus();
	}

	INDRA_addAncillary(passenger: any) {
		// let selStop = this.INDRA_getAddOnForPassenger(passenger.idPax) && this.INDRA_getAddOnForPassenger(passenger.idPax).length > 1 ? this.selectedStop : 0;
		let selStop = this.INDRA_getAddedAncillariesForPassenger(passenger.idPax) && this.INDRA_getAddedAncillariesForPassenger(passenger.idPax).length > 1 ? this.selectedStop : 0;
		let selStopSegIndex;
		if (this.INDRA_getAddOnForPassenger(passenger.idPax) && this.INDRA_getAddOnForPassenger(passenger.idPax).length > 1) {
			this.INDRA_getAddOnForPassenger(passenger.idPax).map((data, index) => {
				if (data.segmentId == (this.flightStop.idInfoSegment)) {
					selStopSegIndex = index;
				}
			});
		} else {
			selStopSegIndex = 0;
		}

		this.hasAddedExtrasFlag = this.INDRA_handleAddAncillary(this.INDRA_getAddOnForPassenger(passenger.idPax)[selStopSegIndex]);

		let ancillaryDetails = this.INDRA_getAddedAncillariesForPassenger(passenger.idPax)[selStop];

		this.addedAncillary.push(ancillaryDetails);

		this.milesNeeded = this.milesNeeded + (ancillaryDetails ? ancillaryDetails.points : 0);
	}

	INDRA_removeAncillary(passenger: any) {
		// let selStop = this.INDRA_getAddedAncillariesForPassenger(passenger.idPax) && this.INDRA_getAddedAncillariesForPassenger(passenger.idPax).length > 1 ? this.selectedStop : 0;
		let selStopSegIndex;

		if (this.INDRA_getAddedAncillariesForPassenger(passenger.idPax) && this.INDRA_getAddedAncillariesForPassenger(passenger.idPax).length > 1) {
			this.INDRA_getAddedAncillariesForPassenger(passenger.idPax).map((data, index) => {
				if (data.segmentId == (this.flightStop.idInfoSegment)) {
					selStopSegIndex = index;
				}
			});
		} else {
			selStopSegIndex = 0;
		}


		this.removedAncillary = this.INDRA_getAddedAncillariesForPassenger(passenger.idPax)[selStopSegIndex];
		this.addedAncillary = this.addedAncillary.filter(item => item.paxId != this.removedAncillary.paxId && item.segmentId != this.removedAncillary.segmentId);

		this.hasAddedExtrasFlag = this.INDRA_handleRemoveAncillary(this.removedAncillary);
		this.milesNeeded = this.milesNeeded - this.removedAncillary.points;

		sessionStorage.removeItem("is"+EXTRAS_ANCILLARY_PREF_BOARD+"withMiles");
		this.INDRA_checkMiles();
	}

	INDRA_processAncillary() {
		this.notEnoughMilesFlag = this.INDRA_handleProcessAncillaries(EXTRAS_ANCILLARY_PREF_BOARD, this.addedAncillary, this.milesNeeded, this.booked_trip);
	}

	INDRA_selectedStop(value) {
		this.selectedStop = value;
		this.flightStop = this.flight.listSegment[this.selectedStop];
	}
	
	INDRA_checkAncillaryInPack() {
		if (this.shoppingCartContent.itemsAdded.length) {
			this.shoppingCartContent.itemsAdded.forEach(item => {
				if (ANCILLARY_PRODUCT_PACKS.includes(item.code)) {
					// Item is pack
					for (let i = 0; i < this.activeBookedTrip['ancillaries-data'].packList.length; i++) {
						let pack = this.activeBookedTrip['ancillaries-data'].packList[i];
						if (pack.ancillaryList[0].type === item.code && item.segmentId === this.flightStop.idInfoSegment) {
							if (pack.ancillaryList[0].catalog[0].passengers[0].codeList[0].ancillaryPackInfo.ancillaryDescription.find(anc => anc.code === SSR_CODE_PREF_BOARD)) {
								this.addedByPack = true;	
							}
						} else {
							this.addedByPack = false;
						}
					}
				}
			});
		}
		return this.addedByPack;
	}

	INDRA_hasActivePrefBoardOnSegment(idPax: number, segmentId: number) {
		let addedAnc = this.INDRA_getAddedAncillariesForPassenger(idPax);
		let flag = false;
		if (addedAnc && addedAnc.length > 0) {
			addedAnc.map(data => {
				if (data.segmentId === segmentId) {
					flag = true;
				}
			});
		}
		return flag;
	}

	INDRA_getLocation(code: string) {
		return this.bookingService.INDRA_getLocation(code).city;
	}


	INDRA_loadChangeFlightCard(incomingFlightId) {
		let idFlight;
		if (!this.prevFlightId || this.prevFlightId != incomingFlightId) {
			idFlight = incomingFlightId
		} else {
			idFlight = this.prevFlightId;
		}
		// this.router.navigate([
		// 	{ outlets: { sidebar: ['preferred-boarding', { flight: idFlight }] } }
		// ]);
		this.stops = [];
		this.selectedStop = null;
		this.INDRA_loadSegmentedControlRadio();
	}

	INDRA_loadSegmentedControlRadio() {
		//fills input for segmented control radio
		let segmentIndex = 0;
		let firstSegmentId = 0;

		for (let i = 0; i < this.flight.listSegment.length; i++) {
			const segment = this.flight.listSegment[i];
			this.stops.push({
				label: segment.departureAirport + '-' + segment.arrivalAirport,
				value: segmentIndex
			});

			const idInfoSegment = segment.idInfoSegment;
			if (segmentIndex === 0) {
				firstSegmentId = idInfoSegment;
			}

			segmentIndex++;
		}

		if (!this.selectedStop) {
			this.INDRA_selectedStop(0); //first segment of the flight
		}
	}

	INDRA_gotoURLMilesGo() {
		let urlNavigate;
		switch (this.language) {
			case 'pt':
				urlNavigate = 'https://www.flytap.com/pt-pt/miles-and-go/parceiros/cartao-credito-tap-miles-and-go';
				break;
			case 'en':
				urlNavigate = 'https://www.flytap.com/en-pt/miles-and-go/partners/tap-miles-and-go-credit-card';
				break;
			default: break;
		}
		
		window.open(urlNavigate);
	}

	INDRA_checkMiles(){
		
		const shoppingCartItems = this.storageService.get('INDRAAncillariesShoppingCartService.shoppingCart');
		const prefItems:any = [];
		if(shoppingCartItems.itemsAdded.length === 0 ){
				return false;
		} else if (shoppingCartItems.itemsAdded.length != 0){
				for (const i in shoppingCartItems.itemsAdded) {
					if(shoppingCartItems.itemsAdded[i].code === "PBRD"){

						prefItems.push(shoppingCartItems.itemsAdded[i]);

						if(prefItems.length < 1){
							return false;
						}

						const isPaidWithMiles = sessionStorage.getItem("is"+shoppingCartItems.itemsAdded[i].type+"withMiles");
						if(isPaidWithMiles === null){
							return false;
						}
						if(String(shoppingCartItems.itemsAdded[i].payWithMiles) === isPaidWithMiles){
							return false;
						} else {
							return true;
						}
					}
	
				}
		}

		return false;
		
	}
}
